define("@latermedia/ember-later-analytics/components/ui/media-kit/fees-callout", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (or this.imageRates this.videoRates @email)}}
    <div class="cCI--booking" ...attributes>
      {{#if (or this.imageRates this.videoRates)}}
        <h2 class="o--page__title">From ${{this.lowestRate}} <span class="u--text--base u--text--hair">/content</span></h2>
      {{/if}}
      {{#if @email}}
        <a href="mailto:{{@email}}" target="_blank" rel="noopener noreferrer" class="cCI--booking__btn qa--mediaKit_clientPage_contactMe_btn">Contact Me</a>
      {{/if}}
      {{!-- Booking Items --}}
      {{#if this.imageRates}}
        {{!-- Divider --}}
        <hr class="u--m__tb">
        {{!-- Booking Item --}}
        <div class="cCI--bookingItem">
          <div class="cCI--bookingItem__title qa--mediaKit_clientPage_imageContent_title">Image Content</div>
          <div class="cCI--bookingItem__value qa--mediaKit_clientPage_imageContent_rate">
            From ${{this.imageRates.min_amount}}
            {{#if this.imageRates.max_amount}}
              - ${{this.imageRates.max_amount}}
            {{/if}}
          </div>
          <div class="cCI--bookingItem__description">Instagram feed posts, carousel posts, etc.</div>
        </div>
      {{/if}}
      {{#if this.videoRates}}
        {{!-- Divider --}}
        <hr class="u--m__tb">
        {{!-- Booking Item --}}
        <div class="cCI--bookingItem">
          <div class="cCI--bookingItem__title qa--mediaKit_clientPage_videoContent_title">Video Content</div>
          <div class="cCI--bookingItem__value qa--mediaKit_clientPage_videoContent_rate">
            From ${{this.videoRates.min_amount}}
            {{#if this.videoRates.max_amount}}
              - ${{this.videoRates.max_amount}}
            {{/if}}
          </div>
          <div class="cCI--bookingItem__description">Instagram Stories, Reels, TikTok etc.</div>
        </div>
      {{/if}}
      {{#if @otherTypesOfCollaboration}}
        {{!-- Divider --}}
        <hr class="u--m__tb">
        {{!-- Booking Item --}}
        <div class="cCI--bookingItem">
          <div class="cCI--bookingItem__description u--p__0 u--m__0 qa--mediaKit_clientPage_openToOtherCollab">Open to creating other forms of content and other collaboration types</div>
        </div>
      {{/if}}
    </div>
  {{/if}}
  
  */
  {
    "id": "UvBxPinW",
    "block": "[[[41,[28,[37,1],[[30,0,[\"imageRates\"]],[30,0,[\"videoRates\"]],[30,1]],null],[[[1,\"  \"],[11,0],[24,0,\"cCI--booking\"],[17,2],[12],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"imageRates\"]],[30,0,[\"videoRates\"]]],null],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--page__title\"],[12],[1,\"From $\"],[1,[30,0,[\"lowestRate\"]]],[1,\" \"],[10,1],[14,0,\"u--text--base u--text--hair\"],[12],[1,\"/content\"],[13],[13],[1,\"\\n\"]],[]],null],[41,[30,1],[[[1,\"      \"],[10,3],[15,6,[29,[\"mailto:\",[30,1]]]],[14,\"target\",\"_blank\"],[14,\"rel\",\"noopener noreferrer\"],[14,0,\"cCI--booking__btn qa--mediaKit_clientPage_contactMe_btn\"],[12],[1,\"Contact Me\"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"imageRates\"]],[[[1,\"      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cCI--bookingItem\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__title qa--mediaKit_clientPage_imageContent_title\"],[12],[1,\"Image Content\"],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__value qa--mediaKit_clientPage_imageContent_rate\"],[12],[1,\"\\n          From $\"],[1,[30,0,[\"imageRates\",\"min_amount\"]]],[1,\"\\n\"],[41,[30,0,[\"imageRates\",\"max_amount\"]],[[[1,\"            - $\"],[1,[30,0,[\"imageRates\",\"max_amount\"]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__description\"],[12],[1,\"Instagram feed posts, carousel posts, etc.\"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"videoRates\"]],[[[1,\"      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cCI--bookingItem\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__title qa--mediaKit_clientPage_videoContent_title\"],[12],[1,\"Video Content\"],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__value qa--mediaKit_clientPage_videoContent_rate\"],[12],[1,\"\\n          From $\"],[1,[30,0,[\"videoRates\",\"min_amount\"]]],[1,\"\\n\"],[41,[30,0,[\"videoRates\",\"max_amount\"]],[[[1,\"            - $\"],[1,[30,0,[\"videoRates\",\"max_amount\"]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__description\"],[12],[1,\"Instagram Stories, Reels, TikTok etc.\"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,3],[[[1,\"      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cCI--bookingItem\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__description u--p__0 u--m__0 qa--mediaKit_clientPage_openToOtherCollab\"],[12],[1,\"Open to creating other forms of content and other collaboration types\"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@email\",\"&attrs\",\"@otherTypesOfCollaboration\"],false,[\"if\",\"or\"]]",
    "moduleName": "@latermedia/ember-later-analytics/components/ui/media-kit/fees-callout.hbs",
    "isStrictMode": false
  });

  class FeesCalloutComponent extends _component2.default {
    get lowestRate() {
      var _sortedRates$;

      if (!this.args.rates) return 0;
      const sortedRates = [...this.args.rates].filter(rate => rate.max_amount).sort((a, b) => (a === null || a === void 0 ? void 0 : a.min_amount) - (b === null || b === void 0 ? void 0 : b.min_amount));
      return (sortedRates === null || sortedRates === void 0 ? void 0 : (_sortedRates$ = sortedRates[0]) === null || _sortedRates$ === void 0 ? void 0 : _sortedRates$.min_amount) || 0;
    }

    get imageRates() {
      var _this$args$rates, _imageRates$;

      const imageRates = (_this$args$rates = this.args.rates) === null || _this$args$rates === void 0 ? void 0 : _this$args$rates.filter(rate => rate.post_type === 'image');

      if (imageRates !== null && imageRates !== void 0 && (_imageRates$ = imageRates[0]) !== null && _imageRates$ !== void 0 && _imageRates$.max_amount) {
        return imageRates === null || imageRates === void 0 ? void 0 : imageRates[0];
      }

      return;
    }

    get videoRates() {
      var _this$args$rates2, _videoRates$;

      const videoRates = (_this$args$rates2 = this.args.rates) === null || _this$args$rates2 === void 0 ? void 0 : _this$args$rates2.filter(rate => rate.post_type === 'video');

      if (videoRates !== null && videoRates !== void 0 && (_videoRates$ = videoRates[0]) !== null && _videoRates$ !== void 0 && _videoRates$.max_amount) {
        return videoRates === null || videoRates === void 0 ? void 0 : videoRates[0];
      }

      return;
    }

  }

  _exports.default = FeesCalloutComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FeesCalloutComponent);
});